<template>
  <v-btn
    variant="text"
    :icon="modelValue ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'"
    color="grey"
    @click="toggle"
  />
</template>

<script>
export default {
  name: "RadioButton",

  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },

  emits: ["update:modelValue"],

  methods: {
    toggle() {
      this.$emit("update:modelValue", !this.modelValue)
    }
  }
}
</script>
